export default {
  contextTypes: {
    sharedBindings() {},
  },

  getSharedBinding(name) {
    return this.context.sharedBindings[name];
  },
};
